import type { ReactNode } from "react";

/** 로그인 등 비인증 화면의 가운데 정렬 템플릿 — 로고·제품명·카드. */
export default function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="auth-layout">
      <main className="auth-layout__box">
        <div className="auth-layout__brand">
          <img src="/logo.svg" alt="" width={56} height={28} />
          <h1 className="auth-layout__title">위차 CSMS</h1>
        </div>
        {children}
      </main>
      <footer className="auth-layout__foot">© UNITCONNECT</footer>
    </div>
  );
}
